const featureItems = [
  {
    icon: 'ri-shield-check-line',
    title: '三方交叉验证',
    desc: '每条17吃瓜爆料均经过AI初筛、编辑复核与主编终审三级把关，内幕吃瓜附带可信度标签，拒绝谣言传播。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '全天候实时追踪',
    desc: '7×24小时监控娱乐圈黑料动态，17吃瓜黑料网团队遍布多个内容源，重大事件发生后两小时内完成核实发布。',
  },
  {
    icon: 'ri-group-line',
    title: '百万吃瓜群众社区',
    desc: '汇聚全网吃瓜爱好者，17黑料吃瓜话题广场日均互动量超百万。理性讨论、文明吃瓜，共建优质娱乐资讯生态。',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-accent-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            为什么选择我们
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="rounded-xl p-6 md:p-7 bg-background-100 border border-background-200/70 transition-all duration-300 cursor-pointer hover:border-primary-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${item.icon} text-xl md:text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-800 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}